export enum StateFormNames {
  QldFormName = 'Agreement',
  NSWFormName = 'Agreement',
}

export default StateFormNames;
